import Mgr from "@/services/SecurityService";
import HTTP from "@/http-common";

let mgr = new Mgr();
export const state = {
  roles: null,
  rolesResolved: false,
  bulkUploadLookupFailed: false,
  user: {
    email: ""
  },
  isUserMember: false
};

export const getters = {
  isAdmin: state => {
    return state.roles && state.roles.includes("ConnectAdmin");
  },
  isSuperAdmin: state => {
    return state.roles && state.roles.includes("ConnectSuperAdmin");
  },
  isBulkUploadAdmin: state => {
    if (state.bulkUploadLookupFailed) return false;
    return state.roles && state.roles.includes("ConnectBulkUploadAdmin");
  },
  isAllowed: state => {
    return state.roles && state.roles.includes("Connect");
  },
  isNbnEeAdmin: state => {
    return state.roles && state.roles.includes("NbnEEAdmin");
  },
  roles: state => {
    return state.roles;
  },
  rolesResolved: state => {
    return state.rolesResolved === true;
  },
  user: state => {
    return state.user;
  },
  isUserMember: state => {
    return state.isUserMember;
  }
};

export const mutations = {
  SET_ROLES(state, val) {
    state.roles = val;
    state.rolesResolved = true;
    state.bulkUploadLookupFailed = false;
  },
  MARK_ROLES_RESOLVED(state) {
    state.rolesResolved = true;
    state.bulkUploadLookupFailed = true;
  },
  CLEAR_ROLES_RESOLUTION(state) {
    state.rolesResolved = false;
    state.bulkUploadLookupFailed = false;
  },
  SET_USER(state, user) {
    state.user = {
      email: user
    };
  },
  SET_USER_MEMBER(state, data) {
    state.isUserMember = data;
  }
};
export const actions = {
  setRoles({ commit }, roles) {
    commit("SET_ROLES", roles);
  },
  markRolesResolved({ commit }) {
    commit("MARK_ROLES_RESOLVED");
  },
  async checkUser({ dispatch, commit }) {
    try {
      let orders = await HTTP.post("OptusNBN/CheckUser");
      commit("SET_USER", orders.data);
      dispatch(`processLoader/setProcessInactive`, {}, { root: true });
      return Promise.resolve(orders.data);
    } catch (e) {
      let message = "";
      if (e.response.data.status == 401) {
        dispatch(
          "httpResponse/setHttpResponse",
          { text: "Unauthorized", color: "error" },
          { root: true }
        );
        return Promise.reject(e);
      }

      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      return Promise.reject(e);
    }
  },
  async isImpersonatedAdmin({ dispatch, commit }) {
    try {
      let result = await HTTP.post("OptusNBN/IsUserMember");
      commit("SET_USER_MEMBER", result.data);
      dispatch(`processLoader/setProcessInactive`, {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.response.data, color: "error" },
        { root: true }
      );
      return Promise.reject(e);
    }
  }
};
